export var ActGraphsWording;
(function (ActGraphsWording) {
    ActGraphsWording["LoggedEmissions"] = "LoggedEmissions";
    ActGraphsWording["ForecastedEmissions"] = "ForecastedEmissions";
    ActGraphsWording["SelectedClimateActions"] = "SelectedClimateActions";
})(ActGraphsWording || (ActGraphsWording = {}));
export var ActGraphsType;
(function (ActGraphsType) {
    ActGraphsType["FORECAST"] = "forecast";
    ActGraphsType["ACTUALS"] = "actuals";
    ActGraphsType["TARGET"] = "target";
    ActGraphsType["ACTION"] = "action";
    ActGraphsType["REMAINING"] = "remaining";
    ActGraphsType["REDUCTION"] = "reduction";
})(ActGraphsType || (ActGraphsType = {}));
export var ActGraphsFormat;
(function (ActGraphsFormat) {
    ActGraphsFormat["RANGE"] = "RANGE";
    ActGraphsFormat["BAR"] = "BAR";
    ActGraphsFormat["LINE"] = "LINE";
    ActGraphsFormat["STEP_LINE"] = "STEP_LINE";
})(ActGraphsFormat || (ActGraphsFormat = {}));
//# sourceMappingURL=ActGraphs.js.map